var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg003Dnote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "35px",
    viewBox: "0 0 36 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 53") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.14528116 6.60815543 0.14528116 6.60815543 5.26843469 0 5.26843469"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tom",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28-Copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#39C5EE",
    points: "5.23069813 7.65345474 5.23069813 27.6806247 21.5423169 27.6806247 25.2752385 23.948016 25.2752385 7.65345474"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#1192C5",
    points: "8.52181611 15.6917868 21.8577702 15.6917868 21.8577702 14.4418981 8.52181611 14.4418981"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#1192C5",
    points: "8.52181611 19.2755731 21.8577702 19.2755731 21.8577702 18.0258409 8.52181611 18.0258409"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#1192C5",
    points: "8.52181611 22.8598288 21.8577702 22.8598288 21.8577702 21.6099401 8.52181611 21.6099401"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#1192C5",
    points: "21.5423795 23.9479534 21.5423795 27.6807186 25.2753011 23.9479534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#21A8D2",
    points: "5.23066683 11.6695144 25.2752072 11.6695144 25.2752072 7.65334519 5.23066683 7.65334519"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#1192C5",
    points: "5.23066683 11.9194296 25.2752072 11.9194296 25.2752072 11.4197558 5.23066683 11.4197558"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(5.000000, 11.077306)",
    fill: "#C1E7F4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "0.230823317 1.34179712 20.2752072 1.34179712 20.2752072 0.842123317 0.230823317 0.842123317"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70635109,12.452365 C6.67278391,12.4632672 6.64007742,12.4664231 6.60622333,12.4776122 L9.02793811,16.1998403 L7.81119929,11.958038 C7.46548595,12.1514079 7.09796828,12.3203915 6.70635109,12.452365",
    id: "Fill-10",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86643887,5.31239474 C7.41008575,4.459157 9.88200786,5.36518416 10.3906799,7.33560675 C10.8984912,9.30689005 9.24996928,11.5983527 6.7063224,12.4524511 C4.16267553,13.3071233 1.68903202,12.4010962 1.18122072,10.4289522 C0.672835625,8.4568082 2.32365269,6.16706697 4.86643887,5.31239474",
    id: "Fill-12",
    fill: "#C13833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58220799,4.66517919 C7.09314838,3.82198292 9.54326617,4.74579782 10.0527989,6.73142607 C10.5654874,8.71418532 8.94594237,11.0070824 6.43414129,11.8520001 C3.9232009,12.6946226 1.47480451,11.769947 0.961829026,9.78431874 C0.450861839,7.80041189 2.0724152,5.50837547 4.58220799,4.66517919",
    id: "Fill-14",
    fill: "#F27273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0527702,6.73134 C9.98620959,6.46825358 9.88206524,6.2243894 9.75009168,6.00089505 C9.80058591,6.12196644 9.84591596,6.24791512 9.87862245,6.37902798 C10.3907372,8.36264793 8.76832317,10.6561188 6.25594829,11.4990282 C4.08067978,12.2294732 1.94959373,11.630428 1.08889661,10.1632263 C1.79753724,11.8823253 4.08813916,12.6380174 6.4341126,11.8522009 C8.94591368,11.0072833 10.5657456,8.71409925 10.0527702,6.73134",
    id: "Fill-16",
    fill: "#F7B1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74707736,7.08603328 C8.16480236,8.05517823 7.6159645,9.19330672 6.52058397,9.62709806 L5.9137925,9.86751946 C4.81927267,10.3021715 3.59363998,9.86751946 3.17448048,8.9000959 L1.01413072,3.88596141 C0.596405721,2.91595576 1.14495668,1.77954867 2.24119791,1.34489662 L2.84741558,1.10361453 C3.94164851,0.669823185 5.1690026,1.10361453 5.58758829,2.07362018 L7.74707736,7.08603328 Z",
    id: "Fill-18",
    fill: "#E94F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.86402703,0.837142704 C4.68554903,0.240392704 6.41555023,0.792386454 6.73257367,2.06937407 C7.04873641,3.34636169 5.83056309,4.8660659 4.01162319,5.4628159 C2.18981429,6.0607135 0.460099988,5.50814595 0.14307655,4.23144523 C-0.173659988,2.95388381 1.04508713,1.4338927 2.86402703,0.837142704",
    id: "Fill-20",
    fill: "#C13833"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72620073,0.378219002 C4.52276251,-0.210210925 6.23813186,0.354693281 6.55687669,1.63914028 C6.87533463,2.92530867 5.67753114,4.44587357 3.87953487,5.03602489 C2.08412069,5.62330722 0.370185829,5.05955061 0.0514409976,3.77338222 C-0.267877632,2.48549244 0.931647248,0.968370325 2.72620073,0.378219002",
    id: "Fill-22",
    fill: "#F27273",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.87939142,4.68282349 C2.08397724,5.27211411 0.37004238,4.7072099 0.0515844471,3.42132841 C0.0320753125,3.34300498 0.0188779567,3.26554224 0.0102709856,3.1857843 C-0.00550846154,3.38431844 0.00453300481,3.58084428 0.0515844471,3.77335353 C0.37004238,5.05952192 2.08397724,5.62327853 3.87939142,5.0359962 C5.56836606,4.48027276 6.72743817,3.10573947 6.59632531,1.8746557 C6.50050103,3.0067593 5.40942399,4.18247156 3.87939142,4.68282349",
    id: "Fill-25",
    fill: "#F7B1B3"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-Copy-6",
    fill: "#3FAE29",
    cx: 25.6456982,
    cy: 24.5519482,
    r: 9.98944823
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3514808,24.889216 C27.3727937,24.7800339 27.3840111,24.6674867 27.3840111,24.5519481 C27.3840111,23.7880477 26.8915701,23.1393118 26.2065649,22.9056173 L26.2065649,20.0144242 C26.2065649,19.6305296 26.5672022,19.345871 26.9393933,19.4397975 C29.2253365,20.0166302 30.9174714,22.0867893 30.9174714,24.5519481 C30.9174714,25.0467448 30.8493448,25.5256875 30.7217663,25.97984 C30.6170338,26.3526294 30.1907751,26.5285172 29.8554142,26.3349061 L27.3514808,24.889216 Z M25.6456981,29.8237214 C24.1669169,29.8237214 22.8304463,29.2149193 21.8727851,28.2342251 C21.6018864,27.9567831 21.6617496,27.4994149 21.9975218,27.305542 L24.5007822,25.8602632 C24.8066415,26.1279836 25.2071004,26.2902611 25.6456981,26.2902611 C26.0842959,26.2902611 26.4847548,26.1279836 26.7902402,25.8602632 L29.2935753,27.3055794 C29.6293475,27.4994523 29.6892107,27.9568205 29.4183121,28.2342251 C28.4608378,29.2149193 27.1241428,29.8237214 25.6456981,29.8237214 L25.6456981,29.8237214 Z M21.4355708,26.3349434 C21.1002098,26.5285546 20.6739885,26.3526668 20.569256,25.9798774 C20.4416775,25.5257249 20.3735509,25.0467448 20.3735509,24.5519481 C20.3735509,22.0867519 22.0657606,20.0165555 24.3520029,19.4397601 C24.7242315,19.345871 25.0848314,19.6305296 25.0848314,20.0143868 L25.0848314,22.9056173 C24.3998262,23.1393118 23.9070113,23.7880477 23.9070113,24.5519481 C23.9070113,24.6674867 23.9182286,24.7800339 23.9399155,24.889216 L21.4355708,26.3349434 Z M25.6456981,17.878008 C21.959682,17.878008 18.971758,20.865932 18.971758,24.5519481 C18.971758,28.2375903 21.959682,31.2258882 25.6456981,31.2258882 C29.3313403,31.2258882 32.3196382,28.2375903 32.3196382,24.5519481 C32.3196382,20.865932 29.3313403,17.878008 25.6456981,17.878008 L25.6456981,17.878008 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg003Dnote);
export default __webpack_public_path__ + "static/media/003-dnote.99e926b76070adb394b0fc7ce95a7090.svg";
export { ForwardRef as ReactComponent };